import { theme } from '../tokens/js/theme';
export const getIconSizePx = (size) => {
    switch (size) {
        case 'sm':
            return '16px';
        case 'md':
            return '24px';
        case 'lg':
            return '64px';
        default:
            throw Error('Unsupported icon size: ' + size);
    }
};
const convertThemeColorKeyToValue = (color) => {
    return theme.color[color];
};
export const convertIconPropsToSvgProps = ({ testId, size, color, ...rest }) => {
    const fontSize = getIconSizePx(size ?? 'md');
    return {
        ...rest,
        fontSize,
        role: 'img',
        'data-testid': testId,
        fill: convertThemeColorKeyToValue(color ?? 'neutral80'),
    };
};
